export const titles = [
  "Réserver une consultation",
  "Motif de la consultation",
  "Choix du praticien",
  "Choix du rendez-vous",
  "Confirmation",
  "Validation de votre rendez-vous",
  "Erreur",
  "Annulation",
];

export const establishment = [
  {
    id: 1,
    name: "Clinique Sainte-Anne",
    type: "Clinique",
    city: "Strasbourg - 67100",
  },
  {
    id: 2,
    name: "Centre Medical Jobert",
    type: "Groupement Médical",
    city: "Haguenau - 67500",
  },
  {
    id: 3,
    name: "Centre Medical Europe",
    type: "Groupement Médical",
    city: "Thionville - 57100",
  },
  {
    id: 4,
    name: "Clinique Les Bleuets",
    type: "Clinique",
    city: "Strasbourg - 67100",
  },
  {
    id: 5,
    name: "Cabinet La Fontaine",
    type: "Groupement Médical",
    city: "Strasbourg - 67000",
  },
  {
    id: 6,
    name: "Centre Rousseau",
    type: "Groupement Médical",
    city: "Thionville - 57100",
  },
  {
    id: 7,
    name: "Mutuelle du Centre",
    type: "Groupement Médical",
    city: "Strasbourg - 67200",
  },
];

export const reason = [
  { id: 1, reason: "Bilan podologique" },
  { id: 2, reason: "Soins de pédicurie" },
  { id: 3, reason: "Semelles orthopédique" },
  { id: 4, reason: "Urgence ongle incarné" },
  { id: 5, reason: "Soin pour personne diabètique" },
  { id: 6, reason: "Traitement de verrue plantaire" },
];

export const practitioner = [
  {
    id: 1,
    place: 1,
    name: "Jean-Marc Everie",
    qualification: "Podologue",
    skill: [1, 2, 3, 4, 5, 6],
    location: "Haguenau - 67500",
  },
  {
    id: 2,
    place: 1,
    name: "Gérome Laplace",
    qualification: "Podologue",
    skill: [2, 5, 6],
    location: "Haguenau - 67500",
  },
  {
    id: 3,
    place: 1,
    name: "Alexandra Delfray",
    qualification: "Orthopediste",
    skill: [1, 3, 5],
    location: "Haguenau - 67500",
  },
  {
    id: 4,
    place: 2,
    name: "Leanne Graham",
    qualification: "Pédicure",
    skill: [2, 3, 4],
    location: "Strasbourg - 67100",
  },
  {
    id: 5,
    place: 2,
    name: "Clementine Bauch",
    qualification: "Orthopediste",
    skill: [1, 2, 3, 4],
    location: "Haguenau - 67500",
  },
  {
    id: 6,
    place: 3,
    name: "Ervin Howell",
    qualification: "Podologue",
    skill: [1, 3, 4, 5],
    location: "Haguenau - 67500",
  },
  {
    id: 7,
    place: 3,
    name: "Patricia Lebsack",
    qualification: "Podologue",
    skill: [1, 3, 5, 6],
    location: "Haguenau - 67500",
  },
  {
    id: 8,
    place: 4,
    name: "Chelsey Dietrich",
    qualification: "Podologue",
    skill: [2, 3, 5, 6],
    location: "Haguenau - 67500",
  },
  {
    id: 9,
    place: 4,
    name: "Kurtis Weissnat",
    qualification: "Orthopediste",
    skill: [1, 2, 4, 6],
    location: "Haguenau - 67500",
  },
  {
    id: 10,
    place: 5,
    name: "Glenna Reichert",
    qualification: "Pédicure",
    skill: [1, 3, 4, 5, 6],
    location: "Strasbourg - 67100",
  },
  {
    id: 11,
    place: 5,
    name: "Adelaide, Darwin",
    qualification: "Orthopediste",
    skill: [1, 2, 3, 4, 5],
    location: "Haguenau - 67500",
  },
  {
    id: 12,
    place: 6,
    name: "Riley Schneider",
    qualification: "Podologue",
    skill: [1, 4, 6],
    location: "Haguenau - 67500",
  },
  {
    id: 13,
    place: 7,
    name: "Glenda Lockman",
    qualification: "Orthopediste",
    skill: [2, 3, 4, 5, 6],
    location: "Haguenau - 67500",
  },
  {
    id: 14,
    place: 7,
    name: "Anthony Kreiger",
    qualification: "Pédicure",
    skill: [1, 3, 4, 5, 6],
    location: "Strasbourg - 67100",
  },
];
export const practitionerPlanning = [
  {
    practitionerId: 1,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          false,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 2,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          false,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 3,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          false,
          false,
          true,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 4,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          true,
          true,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          true,
          true,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          false,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          false,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 5,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          false,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 6,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          false,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 7,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          false,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 8,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          false,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 9,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          false,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 10,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          true,
          true,
          false,
          true,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          false,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 11,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          false,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 12,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          true,
          false,
          true,
          false,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          false,
          true,
          true,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 13,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          false,
          false,
          true,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          true,
          true,
        ],
      },
    ],
  },
  {
    practitionerId: 14,
    planning: [
      {
        date: "18 juillet 2022",
        schedule: [
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
        ],
      },
      {
        date: "19 juillet 2022",
        schedule: [
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
          false,
          false,
          false,
          true,
          true,
          false,
        ],
      },
      {
        date: "20 juillet 2022",
        schedule: [
          true,
          true,
          true,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          false,
          false,
          true,
          true,
        ],
      },
      {
        date: "21 juillet 2022",
        schedule: [
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          false,
          true,
          true,
          true,
          true,
          true,
          true,
        ],
      },
    ],
  },
];

export const timeSlot = [
  "9h00",
  "9h30",
  "10h00",
  "10h30",
  "11h00",
  "11h30",
  "14h00",
  "14h30",
  "15h00",
  "15h30",
  "16h00",
  "16h30",
  "17h00",
  "17h30",
];
